import Order from './components/Order';

const OrderPage = () => {
  return (
    <div>
      <Order />
    </div>
  );
};

export default OrderPage;
